import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { withAssessmentPreview } from 'chameleon/ui-stack/hocs/player';
import withLearnosityConfig from 'legacy-src/utility/withLearnosityConfig';
import { useRestoreMathJax } from 'chameleon/ui-stack/hooks/useMathJaxReplace';
import PreviewPlayer from './main';

const AssessmentPreviewPlayer = (props) => {
  const {
    onQuestionChanged,
    questions,
    assessment,
    loading,
    onItemLoad = () => {},
    refetch = () => {},
    getCurrentQuestionIndex,
  } = props;

  useRestoreMathJax();

  useEffect(() => {
    if (loading === false && assessment) {
      onItemLoad(assessment, refetch);
    }
  }, [loading, assessment]);

  return (
    <PreviewPlayer
      {...props}
      onQuestionChanged={(questionId) => {
        if (onQuestionChanged) {
          const currentQuestion = questions.find(
            (question) => question.itemId === questionId,
          );
          onQuestionChanged(currentQuestion);
        }
        if (getCurrentQuestionIndex) {
          const questionIds = questions.map((item) => item.itemId);
          const getQuestionIndex = questionIds.indexOf(questionId);
          getCurrentQuestionIndex(getQuestionIndex);
        }
      }}
    />
  );
};

export default compose(
  withRouter,
  connect((state) => state),
  withLearnosityConfig(),
  withAssessmentPreview,
)(AssessmentPreviewPlayer);
